var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size * (12 / 15),"viewBox":"0 0 15 12","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"transform":`rotate(${_vm.rotation} ${_vm.size*0.5} ${_vm.size*0.5*12/15})`,"d":"M0,12 l7.5,-12 l7.5,12z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }